import { render, staticRenderFns } from "./o-m-languages.vue?vue&type=template&id=64f38aec&"
import script from "./o-m-languages.vue?vue&type=script&lang=js&"
export * from "./o-m-languages.vue?vue&type=script&lang=js&"
import style0 from "./o-m-languages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports